export class UpdateNotificationsCount {
  static readonly type = '[HeaderCounts] Update notifications count';
}

export class UpdateMessagesCount {
  static readonly type = '[HeaderCounts] Update messages count';
}

export class UpdateReviewsCount {
  static readonly type = '[HeaderCounts] Update reviews count';
}
